import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";

import {traceHeadersFor} from "framework/services/trace-headers-interceptor/trace-headers";

import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class TraceHeadersInterceptor implements HttpInterceptor
{
    private readonly m_router = inject(Router);

    public intercept(req: HttpRequest<any>,
                     next: HttpHandler): Observable<HttpEvent<any>>
    {
        const headers = traceHeadersFor(this.currentUrl());
        if (!headers) return next.handle(req);

        return next.handle(req.clone({setHeaders: headers}));
    }

    private currentUrl(): string
    {
        const navigation = this.m_router.getCurrentNavigation();
        return (navigation?.finalUrl ?? navigation?.extractedUrl)?.toString() ?? this.m_router.url;
    }
}
